<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: zh
 * @Date: 2021-10-15 10:13:07
 * @LastEditors: zh
 * @LastEditTime: 2022-01-12 15:20:48
-->
<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/chuguanbg.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <div style="height:55px;"></div>
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <p :class="$i18n.locale=='zh'?'zh-font':'en-font'">{{$t('warehouse2.content')}}</p>
              <img v-if="$i18n.locale == 'zh'" style="width:80%;margin-top:55px;" src="../../assets/images/chuguan.svg">
              <img v-else style="width:80%;margin-top:55px;" src="../../assets/images/chuguan-en.png">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default ({
  data() {
    return {
      lang: 'zh'
    }
  },
  created() {
    this.lang = localStorage.getItem('lang')
  }
})
</script>

<style scoped>
  .topPoint::after {
      width: 25px;
      height: 25px;
      content: "";
      position: absolute;
      background: #ed6d00;
      border-radius: 50%;
      z-index: 1;
      top: -12.5px;
      right: -12.5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/warehousing2/warehousing2.vue